export default "__VITE_ASSET__B4481U90__"